import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { CalificacionComponent } from './calificacion/calificacion.component';
import { authGuardSubmodule } from '../../auth/auth.guard';
import { PlanesComponent } from '../resultados/planes/planes.component';
import { SeguimientoPlanComponent } from './seguimiento-plan/seguimiento-plan.component';
import { ReportesComponent } from '../resultados/reportes/reportes.component';

const routes: Routes = [
  {
    path: 'app/resultados',
    component: ContenedorComponent,
    children: [
      {path: 'calificacion', component: CalificacionComponent, canActivate: [authGuardSubmodule]},
      {path: 'planes', component: PlanesComponent, canActivate: [authGuardSubmodule]},
      {path: 'seguimiento-planes', component: SeguimientoPlanComponent, canActivate: [authGuardSubmodule]},
      {path: 'reporte', component: ReportesComponent, canActivate: [authGuardSubmodule]}

    ],    
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResultadosRoutingModule { }
